import { useQueryConsentCategories } from 'api';
import isEmpty from 'lodash/isEmpty';

export default function useConsentCategories() {
  const { data, loading } = useQueryConsentCategories();

  if (loading || isEmpty(data)) {
    return [];
  }

  return data.map(({ id, name, code }) => ({ value: id, label: `${code} - ${name}` }));
}
